/*
  Swaps the cart's individual books for the set that bundles them.

  Done as a single POST to the cart update endpoint: that endpoint adds a
  variant that isn't in the cart yet, so removing the components (quantity 0)
  and adding the set happen in one request. There is never an intermediate
  state where the shopper holds both and sees an inflated total.

  The listener is delegated from `document` on purpose. CartDrawer.renderContents
  and CartDrawerItems both replace the drawer's markup via innerHTML, which does
  not execute injected <script> tags — a handler bound inside the card would be
  dead after the first cart update.
*/
(function () {
  if (window.cartUpsellBound) return;
  window.cartUpsellBound = true;

  function updateUrl() {
    return (window.routes && window.routes.cart_update_url) || '/cart/update.js';
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cart-upgrade]');
    if (!button || button.disabled) return;

    event.preventDefault();

    var setVariant = button.getAttribute('data-set-variant');
    if (!setVariant) return;

    var removeKeys = (button.getAttribute('data-remove-keys') || '')
      .split('|')
      .filter(function (key) {
        return key !== '';
      });

    var drawer = document.querySelector('cart-drawer');
    var card = button.closest('[data-cart-upsell]');
    var error = card && card.querySelector('[data-cart-upsell-error]');
    var originalText = button.textContent;

    button.disabled = true;
    button.textContent = '…';
    if (error) error.textContent = '';

    // Line item keys drop to 0, the set variant comes in — one atomic update.
    var updates = {};
    removeKeys.forEach(function (key) {
      updates[key] = 0;
    });
    updates[setVariant] = 1;

    var body = { updates: updates };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (parsed) {
        if (parsed.status) {
          throw new Error(parsed.description || parsed.message || 'Cart update failed');
        }
        if (drawer && typeof drawer.renderContents === 'function' && parsed.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(parsed);
        } else {
          // Without section HTML there is nothing to re-render from, and the
          // cart has already changed — reload so the shopper sees the truth.
          window.location.reload();
        }
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = originalText;
        if (error) error.textContent = 'Nu am putut schimba coșul. Mai încearcă o dată.';
      });
  });
})();
